import axios from 'axios';

export const requestTransaction = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/requestTransaction`, data);
        if (response.data) {
        }
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const cancelSubscription = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/cancelSubscription`, data);
        if (response.data) {
        }
        return response.data;
    } catch (error) {
        console.log(error, 'error')
        throw error.response.data;
    }
};
export const applyDiscount = async (subscriptionId, perOff, userId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/applyDiscount`, { stripeSubscriptionId: subscriptionId, perOff, userId });
        if (response.data.success) {
            if (response.data.message == "Discount has already been applied to this account.") {
                return response.data.message;
            }
            return `${perOff} discount applied successfully to your next billing cycle!`;
        } else {
            throw response.data.message || 'Failed to apply the discount.';
        }
    } catch (error) {
        throw error||error.response.data;
    }
};

export const activeFreePlan = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/activeFreeSubscription`, data);
        if (response?.data) {
        }
        return response?.data;
    } catch (error) {
        console.log(error, 'error')
        throw error?.response?.data;
    }
};

export const upgradeSubscription = async (token, newPriceId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/upgradeSubscription`, {
            token,
            newPriceId,
        });
        return response.data;
    } catch (error) {
        console.log(error, 'Error upgrading subscription');
        throw error.response.data;
    }
};

export const downgradeSubscription = async (token, newPriceId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/downgradeSubscription`, {
            token,
            newPriceId,
        });
        return response.data;
    } catch (error) {
        console.log(error, 'Error downgrading subscription');
        throw error.response.data;
    }
};

export const fetchInvoices = async (email, limit, offset = 0) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}payment/getInvoices`, {
            params: { email, limit, offset }, // Include offset parameter for pagination
        });
        return response.data; // Return the fetched invoices
    } catch (error) {
        console.log(error, 'error fetching invoices');
        throw error.response.data; // Throw the error to handle it in the calling component
    }
};
export const getSubcriptionDetail = async (subscriptionId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}payment/getSubcriptionDetail`, {
            params: { stripeSubscriptionId: subscriptionId }, // Send the email and limit as query parameters
        });
        return response; // Return the fetched invoices
    } catch (error) {
        console.log(error, 'error fetching invoices');
        throw error.response.data; // Throw the error to handle it in the calling component
    }
};

export const pauseSubscription = async (token, pauseWeeks) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/pauseSubscription`, {
            token,
            pauseWeeks
        });
        return response.data;
    } catch (error) {
        console.log(error, 'Error pausing subscription');
        throw error.response.data;
    }
};

export const resumeSubscription = async (token) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/resumeSubscription`, {
            token
        });
        return response.data;
    } catch (error) {
        console.log(error, 'Error resuming subscription');
        throw error.response.data;
    }
};